interface TelcoInterface {
    readonly iban: string;
}
export const telcoGlobal: TelcoInterface = {iban: 'BE40 0689 4580 2163'};